document.addEventListener(
  'DOMContentLoaded',
  () => {
    const specLists = document.querySelectorAll('.product-spec[data-collapsible="true"]');
    if (!specLists.length) return;

    specLists.forEach((list) => {
      const items = Array.from(list.querySelectorAll('.product-spec__item'));
      const initiallyVisible = parseInt(list.getAttribute('data-initial-visible') || '8', 10);
      const moreLabel = list.getAttribute('data-more-label') || 'Show all characteristics';
      const lessLabel = list.getAttribute('data-less-label') || 'Show less';

      if (items.length <= initiallyVisible) {
        const toggleBtn = list.nextElementSibling;
        if (toggleBtn && toggleBtn.classList.contains('product-spec__toggle')) {
          toggleBtn.hidden = true;
        }
        return;
      }

      items.forEach((item, index) => {
        if (index >= initiallyVisible) {
          item.setAttribute('hidden', '');
        }
      });

      // The toggle button is rendered inside a centered wrapper just after the list
      let toggleBtn = list.nextElementSibling;
      if (
        toggleBtn &&
        toggleBtn.firstElementChild &&
        toggleBtn.firstElementChild.classList.contains('product-spec__toggle')
      ) {
        toggleBtn = toggleBtn.firstElementChild;
      }
      if (!toggleBtn || !toggleBtn.classList.contains('product-spec__toggle')) return;

      toggleBtn.hidden = false;
      toggleBtn.textContent = moreLabel;

      let expanded = false;
      toggleBtn.addEventListener('click', () => {
        expanded = !expanded;
        items.forEach((item, index) => {
          if (index >= initiallyVisible) {
            if (expanded) {
              item.removeAttribute('hidden');
            } else {
              item.setAttribute('hidden', '');
            }
          }
        });
        toggleBtn.textContent = expanded ? lessLabel : moreLabel;
      });
    });
  },
  { once: true }
);
